import { Component, ElementRef, Input, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Worksheet, WorksheetItem, WorksheetType } from '@fgb/core';

@Component({
  selector: 'fgb-video-gallery',
  templateUrl: './video-gallery.component.html',
  styleUrls: ['./video-gallery.component.scss'],
})
export class VideoGalleryComponent implements OnInit {
  @Input() worksheetGroup: Worksheet;
  @ViewChild('outlet', { read: ViewContainerRef }) outletRef: ViewContainerRef;
  @ViewChild('content', { read: TemplateRef }) contentRef: TemplateRef<any>;
  @ViewChild('videoScroll') videoScrollRef: ElementRef<HTMLElement>;

  worksheetType = WorksheetType;
  firstVideoItem: WorksheetItem | undefined;
  listVideos: WorksheetItem[] | undefined;
  isPlaying: Boolean = false;

  ngOnInit() {
    if (this.worksheetGroup?.Items) {
      this.listVideos = this.worksheetGroup.Items.filter(
        (item) => item.WorksheetType === this.worksheetType.ProviderVideo
      );
      this.firstVideoItem = this.listVideos?.[0];
    }
  }

  rerender() {
    this.outletRef.clear();
    this.outletRef.createEmbeddedView(this.contentRef);
  }

  handleClickPlay(itemId: number): void {
    this.firstVideoItem = this.listVideos?.find((item) => item.Id === itemId);
    this.isPlaying = true;
    this.rerender();
  }

  handleFirstVideoPlay(): void {
    this.isPlaying = true;
    this.rerender();
  }

  prevSlide(): void {
    this.scrollByAmount(-1);
  }

  nextSlide(): void {
    this.scrollByAmount(1);
  }

  private scrollByAmount(direction: number): void {
    const container = this.videoScrollRef?.nativeElement;
    if (!container) {
      return;
    }
    const firstItem = container.querySelector('.carousel-slide-inner') as HTMLElement;
    const gap = 24;
    const itemWidth = firstItem ? firstItem.offsetWidth + gap : container.clientWidth;
    container.scrollBy({ left: direction * itemWidth, behavior: 'smooth' });
  }
}
